import {
  AppNotificationDto,
  AppNotificationGroupDto,
} from '@act/shared/data-transfer-objects';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material';
import { Fragment } from 'react';
import NotificationContent from './notification-content';

interface NotificationGroupContentProps {
  group: AppNotificationGroupDto;
  notifications: AppNotificationDto[];
  onNotificationClick?: () => void;
}

const NotificationGroupContent = ({
  group,
  notifications,
  onNotificationClick,
}: NotificationGroupContentProps) => {
  return (
    <Fragment>
      <Accordion
        sx={{
          width: '100%',
          border: 'none',
          '&.MuiAccordion-root': {
            boxShadow: 'none',
            '&::before': { background: 'none' },
          },
          '&.Mui-expanded': { margin: 0, border: 'none' },
        }}
        square
        defaultExpanded
        disableGutters
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ transform: 'rotate(180)' }} />}
          sx={{ padding: '0 16px' }}
        >
          <Typography variant="bodyLarge">
            {group.label} ({notifications.length})
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ padding: '8px 16px 16px 16px' }}>
          {[...notifications]
            .sort((a, b) => {
              if (b.createdAt > a.createdAt) return 1;
              if (b.createdAt < a.createdAt) return -1;
              return 0;
            })
            .map(notification => (
              <NotificationContent
                key={notification.id}
                notification={notification}
                groupKey={group.key}
                onNotificationClick={onNotificationClick}
              />
            ))}
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

export default NotificationGroupContent;
